"use client"

import { createContext, useContext, type ReactNode } from "react"
import type { AsetMedia, PetaAsetMedia } from "@/modules/media/domain/aset"
import type { KunciSlot } from "@/modules/media/domain/slot"

const KonteksMedia = createContext<PetaAsetMedia>({})

export function MediaProvider({ peta, children }: { peta: PetaAsetMedia; children: ReactNode }) {
  return <KonteksMedia.Provider value={peta}>{children}</KonteksMedia.Provider>
}

export function useAsetMedia(kunci: KunciSlot): AsetMedia | null {
  return useContext(KonteksMedia)[kunci] ?? null
}
